import { createAsyncThunk } from '@reduxjs/toolkit';
import { RegionsApi } from '../http';
import { IRegionsQuery } from '../models';

const regionsApi = new RegionsApi();

export const fetchRegionsAll = createAsyncThunk(
  'regions/all',
  async (body: IRegionsQuery, { rejectWithValue }) => {
    try {
      const data = await regionsApi.findAll(body);
      return { data, page: 1, limit: 9999, total: data.length };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
